import { IAdmin, IBaseAdmin } from 'types/income';
import { converters as tableConverters } from 'store/table';
import { convertAdminRole } from 'store/permissions';
import { loaders } from './admins.loaders';
import { Admin, BaseAdmin } from './admins.types';

const convertBaseAdmin = (admin: IBaseAdmin): BaseAdmin => {
  return {
    id: admin.id,
    status: admin.status,
    email: admin.email ?? '',
    phone: admin.phone ?? '',
    fullName: admin.fullName ?? '',
    adminRole: admin.adminRole ? convertAdminRole(admin.adminRole) : null,
    permissionScopes: admin.permissionScopes ?? [],
  };
};

const convertAdmin = (admin: IAdmin): Admin => {
  return {
    ...convertBaseAdmin(admin),
    firstName: admin.firstName,
    lastName: admin.lastName,
    role: admin.role,
    root: admin.root,
    parentCompanyId: admin.parentCompanyId,
    employeeId: admin.employeeId ?? '',
    apiKeyAbbreviated: admin.apiKeyAbbreviated ?? '',
    clientIntegrationId: admin.clientIntegrationId ?? '',
    integrationType: admin.integrationType ?? null,
    tokens: admin.tokens?.map((token) => ({
      jti: token.jti,
      name: token.name,
      createdAt: token.creationDate,
    })),
  };
};

const convertAdmins = (administrators: IBaseAdmin[]): BaseAdmin[] => {
  return administrators.map(convertBaseAdmin);
};

export const converters = {
  getAdmins: ({ data }: Awaited<ReturnType<typeof loaders.getAdmins>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAdmins(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getAdmin: ({ data }: Awaited<ReturnType<typeof loaders.getAdmin>>) => {
    return convertAdmin(data);
  },
};
